import React from 'react';

export const TrackedPersonnelContext = React.createContext({});

export const useTrackedPersonnelContext = () =>
  React.useContext(TrackedPersonnelContext);
